import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  TrendingUpIcon, 
  UserIcon, 
  BuildingIcon, 
  BriefcaseIcon, 
  SettingsIcon, 
  FileTextIcon,
  CreditCardIcon
} from '../common/Icons';
import './AdminSidebar.css';

const AdminSidebar = ({ isMobileOpen, onClose }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        onClose?.();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [onClose]);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    if (isMobileOpen && isMobile) {
      const handleClickOutside = (e) => {
        if (!e.target.closest('.admin-sidebar') && !e.target.closest('.admin-sidebar__toggle')) {
          onClose?.();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isMobileOpen, isMobile, onClose]);

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: TrendingUpIcon },
    { path: '/admin/employees', label: 'Employees', icon: UserIcon },
    { path: '/admin/employers', label: 'Employers', icon: BuildingIcon },
    { path: '/admin/jobs', label: 'All Jobs', icon: BriefcaseIcon },
    { path: '/admin/payments', label: 'Payments', icon: CreditCardIcon },
    { path: '/admin/job-roles', label: 'Job Roles', icon: SettingsIcon },
    { path: '/admin/documents', label: 'Documents', icon: FileTextIcon },
  ];

  const handleLinkClick = () => {
    if (isMobile) {
      onClose?.();
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {isMobileOpen && isMobile && (
        <div 
          className="admin-sidebar__overlay"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      
      <aside className={`admin-sidebar ${isMobileOpen && isMobile ? 'admin-sidebar--open' : ''}`}>
        <div className="admin-sidebar__header">
          <h2 className="admin-sidebar__title">Admin Panel</h2>
          {isMobile && (
            <button 
              className="admin-sidebar__close"
              onClick={onClose}
              aria-label="Close menu"
            >
              ×
            </button>
          )}
        </div>
        <nav className="admin-sidebar__nav">
          <ul className="admin-sidebar__menu">
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path || 
                (item.path !== '/admin/dashboard' && location.pathname.startsWith(item.path));
              const Icon = item.icon;
              
              return (
                <li key={item.path} className="admin-sidebar__menu-item">
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `admin-sidebar__link ${isActive ? 'admin-sidebar__link--active' : ''}`
                    }
                    onClick={handleLinkClick}
                  >
                    <Icon className="admin-sidebar__icon" size={20} />
                    <span className="admin-sidebar__label">{item.label}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default AdminSidebar;

